import Text from "./Text";

const DSE = () => {
    return (
        <div className="h-full overflow-y-auto p-6 flex flex-col gap-4 bg-white">
            <Text type="main">Datenschutzerklärung</Text>

            <Text>
                Stand: Januar 2026
            </Text>

            <Text>
                Der Schutz deiner persönlichen Daten ist uns ein wichtiges Anliegen. Diese
                Datenschutzerklärung informiert dich darüber, welche personenbezogenen Daten bei der
                Nutzung von <strong>Cashier One</strong> (nachfolgend "die Plattform" genannt) erhoben,
                verarbeitet und gespeichert werden.
            </Text>

            <Text type="title">1. Verantwortliche Stelle</Text>
            <Text>
                Verantwortlich für die Datenverarbeitung ist:
            </Text>
            <Text>
                Oliver Hollenbach<br />
                Oberstieg 31<br />
                8222 Beringen<br />
                Schweiz<br />
                E-Mail: raycraftstudios.ch@gmail.com
            </Text>

            <Text type="title">2. Erhobene Daten & Rechtsgrundlage</Text>
            <Text>
                Bei der Nutzung von Cashier One werden folgende Kategorien personenbezogener Daten
                verarbeitet:
            </Text>
            <Text>
                <strong>Bestandsdaten:</strong> Name, E-Mail-Adresse, Workspace-Name, Passwort (verschlüsselt)
            </Text>
            <Text>
                <strong>Nutzungsdaten:</strong> Produktdaten, Verkaufsdaten, Statistiken, Einstellungen
            </Text>
            <Text>
                <strong>Zahlungsdaten:</strong> Informationen zur Zahlungsabwicklung (werden nicht direkt
                bei uns gespeichert, sondern bei den Zahlungsdienstleistern)
            </Text>
            <Text>
                Die Rechtsgrundlage für die Datenverarbeitung ist primär die Vertragserfüllung
                (Art. 6 Abs. 1 revDSG).
            </Text>

            <Text type="title">3. Zweck der Datenverarbeitung</Text>
            <Text>
                Die Verarbeitung der Daten erfolgt zu folgenden Zwecken:
            </Text>
            <Text>
                • Bereitstellung und Betrieb der Plattform<br />
                • Verwaltung von Benutzerkonten und Workspaces<br />
                • Abwicklung von Abonnements und Zahlungen<br />
                • Technische Sicherheit und Fehlerdiagnose<br />
                • Verbesserung der Dienste und Funktionen<br />
                • Erfüllung gesetzlicher Aufbewahrungspflichten<br />
                • Kommunikation mit dir (Support, Updates, wichtige Hinweise)
            </Text>

            <Text type="title">4. Speicherdauer</Text>
            <Text>
                Personenbezogene Daten werden nur so lange gespeichert, wie dies für den jeweiligen
                Zweck erforderlich ist:
            </Text>
            <Text>
                • <strong>Bestandsdaten:</strong> Für die Dauer des Vertragsverhältnisses plus 30 Tage
                nach Vertragsende für mögliche Wiederherstellung, danach Löschung
            </Text>
            <Text>
                • <strong>Verkaufsdaten:</strong> Wir empfehlen dir, diese entsprechend den steuerrechtlichen
                Aufbewahrungsfristen (10 Jahre) selbst zu exportieren und aufzubewahren. Auf unseren
                Servern werden sie nach Vertragsende 30 Tage vorgehalten
            </Text>
            <Text>
                • <strong>Zahlungsdaten:</strong> Gemäß gesetzlicher Aufbewahrungspflichten (10 Jahre)
            </Text>
            <Text>
                • <strong>Technische Logs:</strong> Maximal 90 Tage
            </Text>

            <Text type="title">5. Weitergabe an Dritte & Auftragsverarbeiter</Text>
            <Text>
                Eine Weitergabe personenbezogener Daten erfolgt nur in folgenden Fällen:
            </Text>
            <Text>
                <strong>Zahlungsdienstleister:</strong> Für die Abwicklung von Zahlungen werden externe
                Zahlungsanbieter eingesetzt. Diese verarbeiten deine Zahlungsdaten gemäß ihren eigenen
                Datenschutzbestimmungen. Wir speichern selbst keine Kreditkartendaten.
            </Text>
            <Text>
                <strong>Hosting-Provider:</strong> Die Plattform wird auf Servern bei Railway
                gehostet. Diese Anbieter haben nur technischen Zugriff im Rahmen der Wartung.
            </Text>
            <Text>
                <strong>Gesetzliche Verpflichtungen:</strong> Bei rechtlichen Anforderungen durch
                Behörden oder Gerichte können wir verpflichtet sein, Daten offenzulegen.
            </Text>
            <Text>
                Es erfolgt keine Weitergabe deiner Daten zu Werbezwecken an Dritte.
            </Text>

            <Text type="title">6. Internationale Datentransfers</Text>
            <Text>
                Die Daten werden ausschließlich auf Servern innerhalb der Schweiz/EU verarbeitet.
            </Text>

            <Text type="title">7. Offline-Nutzung & lokale Datenspeicherung</Text>
            <Text>
                Bei Nutzung der Offline-Funktion werden Daten lokal auf deinem Gerät gespeichert.
                Diese lokalen Daten unterliegen deiner eigenen Verantwortung hinsichtlich der
                Sicherheit des Geräts. Bei erneuter Internetverbindung werden die Daten automatisch
                mit unseren Servern synchronisiert. Du kannst die lokalen Daten jederzeit durch
                Deinstallation der App oder Löschen der Browser-Daten entfernen.
            </Text>

            <Text type="title">8. Kamera-Berechtigung (Mobile App)</Text>
            <Text>
                Die mobile Anwendung benötigt Zugriff auf die Kamera deines Geräts ausschließlich
                zum Scannen von QR-Codes (z.B. für Gutschein-Codes oder Produktinformationen).
            </Text>
            <Text>
                • Die Kamera wird nur aktiviert, wenn du die Scan-Funktion explizit nutzt<br />
                • Es werden keine Fotos oder Videos aufgenommen, gespeichert oder übertragen<br />
                • Die Kameradaten werden ausschließlich lokal auf deinem Gerät verarbeitet<br />
                • Es erfolgt keine Weitergabe von Kamerabildern an unsere Server oder Dritte<br />
                • Du kannst die Kamera-Berechtigung jederzeit in den Geräteeinstellungen widerrufen
            </Text>

            <Text type="title">9. Cookies & Tracking</Text>
            <Text>
                Die Plattform verwendet technisch notwendige Cookies zur Authentifizierung und
                Sitzungsverwaltung. Diese sind für die Funktionsfähigkeit der Plattform erforderlich.
            </Text>
            <Text>
                Wir verwenden keine Tracking-Tools, Analytics oder Cookies von
                Drittanbietern zu Werbezwecken.
            </Text>

            <Text type="title">10. Datensicherheit</Text>
            <Text>
                Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um deine Daten
                vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen:
            </Text>
            <Text>
                • SSL/TLS-Verschlüsselung für die Datenübertragung<br />
                • Verschlüsselte Speicherung von Passwörtern<br />
                • Regelmäßige Sicherheits-Updates<br />
                • Zugriffsbeschränkungen und Zugriffskontrollen<br />
                • Regelmäßige Backups<br />
                • Firewall und Intrusion Detection Systeme
            </Text>
            <Text>
                Trotz dieser Maßnahmen kann keine absolute Sicherheit garantiert werden. Bei
                Sicherheitsvorfällen werden wir dich gemäß den gesetzlichen Vorgaben informieren.
            </Text>

            <Text type="title">11. Deine Rechte als betroffene Person</Text>
            <Text>
                Du hast nach dem schweizerischen Datenschutzgesetz (revDSG) folgende Rechte:
            </Text>
            <Text>
                <strong>Auskunftsrecht:</strong> Du kannst jederzeit Auskunft über die von dir
                gespeicherten personenbezogenen Daten verlangen.
            </Text>
            <Text>
                <strong>Recht auf Berichtigung:</strong> Du kannst die Korrektur unrichtiger Daten verlangen.
            </Text>
            <Text>
                <strong>Recht auf Löschung:</strong> Du kannst die Löschung deiner Daten verlangen,
                sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </Text>
            <Text>
                <strong>Recht auf Einschränkung:</strong> Du kannst die Einschränkung der Verarbeitung
                deiner Daten verlangen.
            </Text>
            <Text>
                <strong>Recht auf Datenportabilität:</strong> Du kannst deine Daten in einem gängigen
                Format herunterladen (Export-Funktion in der Plattform).
            </Text>
            <Text>
                <strong>Widerspruchsrecht:</strong> Du kannst der Verarbeitung deiner Daten widersprechen,
                soweit diese auf berechtigtem Interesse beruht.
            </Text>
            <Text>
                Zur Ausübung dieser Rechte wende dich bitte an: raycraftstudios.ch@gmail.com
            </Text>

            <Text type="title">12. Beschwerderecht</Text>
            <Text>
                Du hast das Recht, dich bei der zuständigen Datenschutz-Aufsichtsbehörde zu beschweren:
            </Text>
            <Text>
                Eidgenössischer Datenschutz- und Öffentlichkeitsbeauftragter (EDÖB)<br />
                Feldeggweg 1<br />
                3003 Bern<br />
                Schweiz<br />
                Tel.: +41 58 462 43 95<br />
                E-Mail: info@edoeb.admin.ch<br />
                Website: www.edoeb.admin.ch
            </Text>

            <Text type="title">13. Automatisierte Entscheidungsfindung</Text>
            <Text>
                Es findet keine automatisierte Entscheidungsfindung einschließlich Profiling statt,
                die dir gegenüber rechtliche Wirkung entfaltet oder dich in ähnlicher Weise erheblich
                beeinträchtigt.
            </Text>

            <Text type="title">14. Minderjährigenschutz</Text>
            <Text>
                Die Nutzung der Plattform ist nur für Personen ab 18 Jahren bestimmt. Wir erheben
                wissentlich keine Daten von Minderjährigen. Sollten wir Kenntnis davon erlangen,
                dass Minderjährige Daten übermittelt haben, werden wir diese unverzüglich löschen.
            </Text>

            <Text type="title">15. Änderungen der Datenschutzerklärung</Text>
            <Text>
                Diese Datenschutzerklärung kann bei sachlichem Grund angepasst werden, insbesondere
                bei Änderungen der Rechtslage oder neuen Funktionen. Über wesentliche Änderungen werden
                wir dich per E-Mail oder durch einen Hinweis bei der Anmeldung informieren. Es gilt
                die jeweils aktuelle Version, die auf der Plattform abrufbar ist.
            </Text>

            <Text type="title">16. Kontakt für Datenschutzfragen</Text>
            <Text>
                Bei Fragen zum Datenschutz, zur Ausübung deiner Rechte oder bei Beschwerden wende
                dich bitte an:
            </Text>
            <Text>
                Oliver Hollenbach<br />
                E-Mail: raycraftstudios.ch@gmail.com
            </Text>

            <Text type="title">17. Anwendbares Recht</Text>
            <Text>
                Es gilt schweizerisches Datenschutzrecht, insbesondere das revidierte
                Datenschutzgesetz (revDSG).
            </Text>
        </div>
    );
}
export default DSE